
import { Vue, Component } from 'vue-property-decorator';
import { List } from 'vant';
import NewsItem from '@/components/next/NewsItem.vue';
import { getNews } from '../api';
Vue.use(List);
@Component({
  components: {
    NewsItem,
  },
})
export default class News extends Vue {
  list: any[] = [];
  page = 1;
  loading = false;
  finished = false;
  loadingStatus = true;
  refreshing: boolean = false;

  goDetail(a: any) {
    const url = a.targetUrl;
    window.location.href = url;
  }
  onLoad() {
    getNews(this.page, '全部', '9259').then((res: any) => {
      this.endListData(res);
    });
  }
  endListData(res: any) {
    this.page = this.page + 1;
    if (res.statusCode === 404) {
      this.finished = true;
    } else {
      if (!res.data.data || res.data.data.length === 0) {
        this.finished = true;
      } else {
        if (!res.data.data[0].list || res.data.data[0].list.length === 0) {
          this.finished = true;
        } else {
          this.list = [...this.list, ...res.data.data[0].list];
        }
      }
    }
    this.loading = false;
  }
}
